import React from "react";
import { FeatherUpload, FeatherUploadCloud } from "@subframe/core";
import { Button } from "../../../../ui/components/Button";
import { IconWithBackground } from "../../../../ui/components/IconWithBackground";

type IconVariant = "brand" | "neutral" | "error" | "success" | "warning";

interface UploadDocumentCardProps {
  title: string;
  icon: React.ReactNode;
  iconVariant?: IconVariant;
  uploadLabel?: string;
  uploadingLabel?: string;
  isUploading?: boolean;
  disabled?: boolean;
  onUpload: () => void;
  bulkUploadDisabled?: boolean;
  onBulkUpload?: () => void;
}

export const UploadDocumentCard: React.FC<UploadDocumentCardProps> = ({
  title,
  icon,
  iconVariant = "neutral",
  uploadLabel = "Upload Single",
  uploadingLabel = "Uploading...",
  isUploading = false,
  disabled = false,
  onUpload,
  bulkUploadDisabled,
  onBulkUpload,
}) => {
  return (
    <div className="flex flex-1 min-w-0 flex-col items-start rounded-md border border-solid border-neutral-border bg-default-background px-4 py-4 gap-6">
      <div className="flex items-center gap-2">
        <IconWithBackground variant={iconVariant} icon={icon} />
        <span className="whitespace-nowrap text-body-bold font-body-bold text-default-font">
          {title}
        </span>
      </div>

      <div className="flex w-full flex-col items-start gap-2">
        <Button
          className="h-8 w-full flex-none"
          icon={isUploading ? null : <FeatherUpload />}
          loading={isUploading}
          onClick={onUpload}
          disabled={disabled || isUploading}
        >
          {isUploading ? uploadingLabel : uploadLabel}
        </Button>

        {onBulkUpload && (
          <Button
            className="h-8 w-full flex-none"
            variant="neutral-tertiary"
            icon={<FeatherUploadCloud />}
            onClick={onBulkUpload}
            disabled={bulkUploadDisabled}
          >
            Bulk Upload
          </Button>
        )}
      </div>
    </div>
  );
};
